import { connect } from 'react-redux';
import { createTemplateSelected } from './wallet-templates.actions';
import { ContentfulToggleView } from './contentful-toggle.view';

export const ContentfulToggle = connect(null, {
  onCreateTemplateSelected: createTemplateSelected,
})(ContentfulToggleView);
